import React, { useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { AccountContext } from '../../../components/AccountContext';
import { useFormikContext } from 'formik';
import _ from 'lodash';
import { defineMessages, useIntl } from 'react-intl';
import { Button } from 'primereact/button';

const messages = defineMessages({
  cancel: { id: 'actions.cancel', defaultMessage: 'Cancel' },
  next: { id: 'actions.next', defaultMessage: 'Next' },
  previous: { id: 'actions.previous', defaultMessage: 'Previous' },
  submit: { id: 'actions.submit', defaultMessage: 'Submit' },
});

const CreateEssentialAccountInvitationFormButtons = ({ step, setStep }) => {
  const currentAccount = useContext(AccountContext);
  const history = useHistory();
  const { formatMessage } = useIntl();
  const { validateForm, isValid, isSubmitting } = useFormikContext();

  const isFirstpage = step === 0;
  const isLastPage = step === 3;

  return (
    <div className="p-col-12">
      {isFirstpage ? (
        <Button
          type="button"
          label={formatMessage(messages.cancel)}
          onClick={() => history.push(`/accounts/${currentAccount}`)}
        />
      ) : (
        <Button
          type="button"
          label={formatMessage(messages.previous)}
          onClick={() => setStep((stepFromState) => stepFromState - 1)}
          disabled={!isValid}
        />
      )}
      <Button
        type="button"
        label={formatMessage(messages.next)}
        onClick={() => {
          validateForm().then((validationErrors) => {
            if (_.isEmpty(validationErrors)) {
              setStep((stepFromState) => stepFromState + 1);
            }
          });
        }}
        disabled={!(isValid && !isLastPage)}
      />
      <Button
        type="submit"
        label={formatMessage(messages.submit)}
        disabled={!(isValid && isLastPage) || isSubmitting}
      />
    </div>
  );
};

export default CreateEssentialAccountInvitationFormButtons;
